'use client';

import { usePathname } from 'next/navigation';
import { useLayoutEffect, type ReactElement } from 'react';

export default function RouterProvider({
  children,
}: Readonly<{ readonly children: ReactElement }>): ReactElement {
  const pathname = usePathname();
  useLayoutEffect(() => {
    if (!pathname.includes('/account/')) window.scrollTo(0, 0);
  }, [pathname]);
  return children;
}
